module.exports = __webpack_public_path__ + "img/post_office.510ffbb1.svg";